import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  actions: {
  	loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/internetRequests`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/internetRequests/page`, { params: pagination })
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.get(`${config.serverURI}/internetRequests/create/${payload}`)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/internetRequests/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('delete', payload)
      return Vue.axios.delete(`${config.serverURI}/internetRequests/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/internetRequest.js